import { Route } from "vue-router";

import store from "@/store";

export const ifNotAuthenticated = async (to: Route, from: Route, next: any) => {
  try {
    await store.dispatch("actualizeUserInfo");
  } catch (err) {
    console.log(err);
  }
  const { role, isLoggedIn } = store.getters;
  if (!isLoggedIn) {
    return next();
  }

  return next({ path: `/${role}` });
};

export const logOutGuard = async (to: Route, from: Route, next: any) => {
  try {
    await store.dispatch("logOut");
  } catch (err) {
    console.log(err);
  }
  const { role, isLoggedIn } = store.getters;
  if (!isLoggedIn) {
    return next();
  }

  return next({ path: `/${role}` });
};

export const roomGuard = async (to: Route, from: Route, next: any) => {
  try {
    await store.dispatch("actualizeUserInfo");
  } catch (err) {
    console.log(err);
  }
  const { isLoggedIn } = store.getters;
  if (!isLoggedIn) {
    return next();
  }
  return next({ name: "PatientEncounter", params: { encounterId: to.params.roomId } });
};

export const ifAuthenticated = async (to: Route, from: Route, next: any) => {
  const redirect = to.path;
  const parentRoute = to.matched.find((record) => record.meta.authorize);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { authorize } = parentRoute!.meta;
  try {
    await store.dispatch("actualizeUserInfo");
    const { role, isLoggedIn } = store.getters;
    if (!role || !isLoggedIn) {
      return next({ path: `/auth/signin?redirect=${redirect}` });
    }
    if (authorize && role && !authorize.includes(role)) {
      next({ path: `/${role}` });
    } else {
      next();
    }
  } catch (err) {
    console.log(err);
  }
};

export const patientListBreadcrumbs = [
  {
    text: "patients.title",
  },
];
export const appointmentsBreadcrumbs = [
  {
    text: "practitioner.appointments.title",
  },
];

export const visitCenterBreadcrumbs = [
  {
    text: "visits.visitCenter",
  },
];

export const chatBreadcrumbs = [
  {
    text: "general.sidebar.messages",
  },
];

export const upcomingAppointmentsBreadcrumbs = [
  ...appointmentsBreadcrumbs,
  {
    text: "visits.upcoming_short",
  },
];

export const appointmentsArchiveBreadcrumbs = [
  ...appointmentsBreadcrumbs,
  {
    text: "visits.archive",
  },
];

export const EditAvailabilityBreadcrumbs = [
  ...appointmentsBreadcrumbs,
  {
    text: "practitioner.appointments.editAvailability.title",
  },
];

export const requestVisitBreadcrumbs = [
  {
    text: "general.sidebar.scheduleVisit",
  },
];

export const visitCenterUpcomingBreadcrumbs = [
  ...visitCenterBreadcrumbs,
  {
    text: "visits.upcoming_short",
  },
];

export const visitCenterArchiveBreadcrumbs = [
  ...visitCenterBreadcrumbs,
  {
    text: "visits.archive",
  },
];

export const practitionerScheduleVisitBreadcrumbs = [
  ...appointmentsBreadcrumbs,
  {
    text: "general.sidebar.scheduleVisit",
  },
];

export const ownerScheduleVisitBreadcrumbs = [
  ...appointmentsBreadcrumbs,
  {
    text: "general.sidebar.scheduleVisit",
  },
];

export const registrarScheduleVisitBreadcrumbs = [
  ...appointmentsBreadcrumbs,
  {
    text: "general.sidebar.scheduleVisit",
  },
];

export const profileSettingsBreadcrumbs = [
  {
    text: "settings.profile.title",
  },
];
